import styled from '@emotion/styled';

export const Root = styled.div<{ showStickyBanner: boolean }>`
  position: relative;
  height: 100%;
  padding-top: ${(props) => (props.showStickyBanner ? '119px' : '80px')};
`;
